import WorkflowLink from './WorkflowLink';

export default WorkflowLink;
